export var ATAwardCategory;
(function (ATAwardCategory) {
    ATAwardCategory["FINALIST"] = "FINALIST";
    ATAwardCategory["HIGHLY_RATED"] = "HIGHLY_RATED";
    ATAwardCategory["WINNER"] = "WINNER";
})(ATAwardCategory || (ATAwardCategory = {}));
export var AdvertCapability;
(function (AdvertCapability) {
    AdvertCapability["DIGITAL_RETAILING"] = "DIGITAL_RETAILING";
    AdvertCapability["GUARANTEED_PART_EX"] = "GUARANTEED_PART_EX";
})(AdvertCapability || (AdvertCapability = {}));
export var AdvertPaymentStatus;
(function (AdvertPaymentStatus) {
    AdvertPaymentStatus["FAILED"] = "FAILED";
    AdvertPaymentStatus["FAILED_INVALID_PAYMENT"] = "FAILED_INVALID_PAYMENT";
    AdvertPaymentStatus["REQUIRES_AUTHENTICATION"] = "REQUIRES_AUTHENTICATION";
    AdvertPaymentStatus["SUCCEEDED"] = "SUCCEEDED";
})(AdvertPaymentStatus || (AdvertPaymentStatus = {}));
export var AdvertPreparePaymentStatus;
(function (AdvertPreparePaymentStatus) {
    AdvertPreparePaymentStatus["ERROR_ADVERT_NOT_FOUND"] = "ERROR_ADVERT_NOT_FOUND";
    AdvertPreparePaymentStatus["ERROR_ADVERT_PACKAGE_CANNOT_BE_SET"] = "ERROR_ADVERT_PACKAGE_CANNOT_BE_SET";
    AdvertPreparePaymentStatus["ERROR_GENERAL"] = "ERROR_GENERAL";
    AdvertPreparePaymentStatus["SUCCESS"] = "SUCCESS";
})(AdvertPreparePaymentStatus || (AdvertPreparePaymentStatus = {}));
export var AdvertReservationEligibility;
(function (AdvertReservationEligibility) {
    AdvertReservationEligibility["ELIGIBLE"] = "ELIGIBLE";
    AdvertReservationEligibility["NOT_ELIGIBLE"] = "NOT_ELIGIBLE";
    AdvertReservationEligibility["RESERVED_ADVERTISER"] = "RESERVED_ADVERTISER";
    AdvertReservationEligibility["RESERVED_AUTO_TRADER"] = "RESERVED_AUTO_TRADER";
})(AdvertReservationEligibility || (AdvertReservationEligibility = {}));
export var AdvertisingLocation;
(function (AdvertisingLocation) {
    AdvertisingLocation["at_bikes"] = "at_bikes";
    AdvertisingLocation["at_caravans"] = "at_caravans";
    AdvertisingLocation["at_cars"] = "at_cars";
    AdvertisingLocation["at_cycles"] = "at_cycles";
    AdvertisingLocation["at_farm"] = "at_farm";
    AdvertisingLocation["at_lease_new_car"] = "at_lease_new_car";
    AdvertisingLocation["at_lease_new_van"] = "at_lease_new_van";
    AdvertisingLocation["at_lease_virtual_car"] = "at_lease_virtual_car";
    AdvertisingLocation["at_lease_virtual_van"] = "at_lease_virtual_van";
    AdvertisingLocation["at_motorhomes"] = "at_motorhomes";
    AdvertisingLocation["at_new_cars"] = "at_new_cars";
    AdvertisingLocation["at_new_cars_migration"] = "at_new_cars_migration";
    AdvertisingLocation["at_plants"] = "at_plants";
    AdvertisingLocation["at_profile_bikes"] = "at_profile_bikes";
    AdvertisingLocation["at_profile_caravans"] = "at_profile_caravans";
    AdvertisingLocation["at_profile_cars"] = "at_profile_cars";
    AdvertisingLocation["at_profile_farm"] = "at_profile_farm";
    AdvertisingLocation["at_profile_motorhomes"] = "at_profile_motorhomes";
    AdvertisingLocation["at_profile_plants"] = "at_profile_plants";
    AdvertisingLocation["at_profile_trucks"] = "at_profile_trucks";
    AdvertisingLocation["at_profile_vans"] = "at_profile_vans";
    AdvertisingLocation["at_trucks"] = "at_trucks";
    AdvertisingLocation["at_vans"] = "at_vans";
})(AdvertisingLocation || (AdvertisingLocation = {}));
export var AuctionStatus;
(function (AuctionStatus) {
    AuctionStatus["CANCELLED"] = "CANCELLED";
    AuctionStatus["CREATED"] = "CREATED";
    AuctionStatus["NOT_PROPOSED"] = "NOT_PROPOSED";
    AuctionStatus["NOT_SOLD"] = "NOT_SOLD";
    AuctionStatus["PROPOSAL_RETRACTED"] = "PROPOSAL_RETRACTED";
    AuctionStatus["PROPOSED"] = "PROPOSED";
    AuctionStatus["PROVISIONAL"] = "PROVISIONAL";
    AuctionStatus["REJECTED"] = "REJECTED";
    AuctionStatus["SOLD"] = "SOLD";
    AuctionStatus["STARTED"] = "STARTED";
})(AuctionStatus || (AuctionStatus = {}));
export var AuctionUpdateStatus;
(function (AuctionUpdateStatus) {
    AuctionUpdateStatus["REJECTED"] = "REJECTED";
})(AuctionUpdateStatus || (AuctionUpdateStatus = {}));
export var AuctionVehicleDetailsAnswerType;
(function (AuctionVehicleDetailsAnswerType) {
    AuctionVehicleDetailsAnswerType["MULTI"] = "MULTI";
    AuctionVehicleDetailsAnswerType["MULTI_FT"] = "MULTI_FT";
    AuctionVehicleDetailsAnswerType["SINGLE"] = "SINGLE";
    AuctionVehicleDetailsAnswerType["SINGLE_FT"] = "SINGLE_FT";
})(AuctionVehicleDetailsAnswerType || (AuctionVehicleDetailsAnswerType = {}));
export var BootSizeValue;
(function (BootSizeValue) {
    BootSizeValue["Large"] = "Large";
    BootSizeValue["Medium"] = "Medium";
    BootSizeValue["Small"] = "Small";
})(BootSizeValue || (BootSizeValue = {}));
export var ChargerLocationType;
(function (ChargerLocationType) {
    ChargerLocationType["HOME"] = "HOME";
    ChargerLocationType["PUBLIC"] = "PUBLIC";
})(ChargerLocationType || (ChargerLocationType = {}));
export var CollectionLocationBadgeType;
(function (CollectionLocationBadgeType) {
    CollectionLocationBadgeType["LOCATION"] = "LOCATION";
    CollectionLocationBadgeType["NEAREST"] = "NEAREST";
})(CollectionLocationBadgeType || (CollectionLocationBadgeType = {}));
export var Condition;
(function (Condition) {
    Condition["NEARLY_NEW"] = "NEARLY_NEW";
    Condition["NEW"] = "NEW";
    Condition["USED"] = "USED";
    Condition["VIRTUAL"] = "VIRTUAL";
})(Condition || (Condition = {}));
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["Friday"] = "Friday";
    DayOfWeek["Monday"] = "Monday";
    DayOfWeek["Saturday"] = "Saturday";
    DayOfWeek["Sunday"] = "Sunday";
    DayOfWeek["Thursday"] = "Thursday";
    DayOfWeek["Tuesday"] = "Tuesday";
    DayOfWeek["Wednesday"] = "Wednesday";
})(DayOfWeek || (DayOfWeek = {}));
export var DealerReviewStatus;
(function (DealerReviewStatus) {
    DealerReviewStatus["ACCEPTED"] = "ACCEPTED";
    DealerReviewStatus["HOLDING"] = "HOLDING";
    DealerReviewStatus["REJECTED"] = "REJECTED";
    DealerReviewStatus["REQUESTED"] = "REQUESTED";
    DealerReviewStatus["SUBMITTED"] = "SUBMITTED";
    DealerReviewStatus["SUSPENDED"] = "SUSPENDED";
})(DealerReviewStatus || (DealerReviewStatus = {}));
export var DealerSort;
(function (DealerSort) {
    DealerSort["DISTANCE"] = "DISTANCE";
    DealerSort["NAME"] = "NAME";
    DealerSort["WITH_RETAILER_REVIEWS"] = "WITH_RETAILER_REVIEWS";
})(DealerSort || (DealerSort = {}));
export var FinanceDisclaimerComponentType;
(function (FinanceDisclaimerComponentType) {
    FinanceDisclaimerComponentType["LINK"] = "LINK";
    FinanceDisclaimerComponentType["TEXT"] = "TEXT";
})(FinanceDisclaimerComponentType || (FinanceDisclaimerComponentType = {}));
export var FinanceProvider;
(function (FinanceProvider) {
    FinanceProvider["DEALER"] = "DEALER";
    FinanceProvider["ZUTO"] = "ZUTO";
})(FinanceProvider || (FinanceProvider = {}));
export var HomeDeliveryOptions;
(function (HomeDeliveryOptions) {
    HomeDeliveryOptions["exclude"] = "exclude";
    HomeDeliveryOptions["include"] = "include";
    HomeDeliveryOptions["only"] = "only";
})(HomeDeliveryOptions || (HomeDeliveryOptions = {}));
export var LeaseContractType;
(function (LeaseContractType) {
    LeaseContractType["business"] = "business";
    LeaseContractType["personal"] = "personal";
})(LeaseContractType || (LeaseContractType = {}));
export var LeaseOfferType;
(function (LeaseOfferType) {
    LeaseOfferType["PROMOTED"] = "PROMOTED";
    LeaseOfferType["SPECIAL"] = "SPECIAL";
})(LeaseOfferType || (LeaseOfferType = {}));
export var MyAdvertsAdvertStatus;
(function (MyAdvertsAdvertStatus) {
    MyAdvertsAdvertStatus["AUCTION"] = "AUCTION";
    MyAdvertsAdvertStatus["AUCTION_COMPLETED"] = "AUCTION_COMPLETED";
    MyAdvertsAdvertStatus["DELETED"] = "DELETED";
    MyAdvertsAdvertStatus["EXPIRED"] = "EXPIRED";
    MyAdvertsAdvertStatus["INCOMPLETE"] = "INCOMPLETE";
    MyAdvertsAdvertStatus["LIVE"] = "LIVE";
    MyAdvertsAdvertStatus["PROCESSING"] = "PROCESSING";
    MyAdvertsAdvertStatus["REBOOKED"] = "REBOOKED";
    MyAdvertsAdvertStatus["REMOVED"] = "REMOVED";
})(MyAdvertsAdvertStatus || (MyAdvertsAdvertStatus = {}));
export var MyAdvertsSortBy;
(function (MyAdvertsSortBy) {
    MyAdvertsSortBy["endDate"] = "endDate";
    MyAdvertsSortBy["startDate"] = "startDate";
})(MyAdvertsSortBy || (MyAdvertsSortBy = {}));
export var MyAdvertsSortOrder;
(function (MyAdvertsSortOrder) {
    MyAdvertsSortOrder["ASC"] = "ASC";
    MyAdvertsSortOrder["DESC"] = "DESC";
})(MyAdvertsSortOrder || (MyAdvertsSortOrder = {}));
export var MyAdvertsStockPerformanceRating;
(function (MyAdvertsStockPerformanceRating) {
    MyAdvertsStockPerformanceRating["ABOVE_AVERAGE"] = "ABOVE_AVERAGE";
    MyAdvertsStockPerformanceRating["BELOW_AVERAGE"] = "BELOW_AVERAGE";
    MyAdvertsStockPerformanceRating["EXCELLENT"] = "EXCELLENT";
    MyAdvertsStockPerformanceRating["NONE"] = "NONE";
    MyAdvertsStockPerformanceRating["POOR"] = "POOR";
})(MyAdvertsStockPerformanceRating || (MyAdvertsStockPerformanceRating = {}));
export var NewsletterSubscriptionState;
(function (NewsletterSubscriptionState) {
    NewsletterSubscriptionState["ExistingUserExistingSubscription"] = "ExistingUserExistingSubscription";
    NewsletterSubscriptionState["ExistingUserNewSubscription"] = "ExistingUserNewSubscription";
    NewsletterSubscriptionState["SoftRegExistingSubscription"] = "SoftRegExistingSubscription";
    NewsletterSubscriptionState["SoftRegNewSubscription"] = "SoftRegNewSubscription";
})(NewsletterSubscriptionState || (NewsletterSubscriptionState = {}));
export var Platform;
(function (Platform) {
    Platform["apps"] = "apps";
    Platform["desktop"] = "desktop";
    Platform["mobile"] = "mobile";
})(Platform || (Platform = {}));
export var PolaAdvertCloneType;
(function (PolaAdvertCloneType) {
    PolaAdvertCloneType["LIVE_EDIT"] = "LIVE_EDIT";
    PolaAdvertCloneType["REBOOK"] = "REBOOK";
})(PolaAdvertCloneType || (PolaAdvertCloneType = {}));
export var PolaAdvertImageRotation;
(function (PolaAdvertImageRotation) {
    PolaAdvertImageRotation["DEGREES_90"] = "DEGREES_90";
    PolaAdvertImageRotation["DEGREES_180"] = "DEGREES_180";
    PolaAdvertImageRotation["DEGREES_270"] = "DEGREES_270";
})(PolaAdvertImageRotation || (PolaAdvertImageRotation = {}));
export var PolaAdvertStatus;
(function (PolaAdvertStatus) {
    PolaAdvertStatus["AUCTION"] = "AUCTION";
    PolaAdvertStatus["AUCTION_COMPLETED"] = "AUCTION_COMPLETED";
    PolaAdvertStatus["DELETED"] = "DELETED";
    PolaAdvertStatus["EXPIRED"] = "EXPIRED";
    PolaAdvertStatus["INCOMPLETE"] = "INCOMPLETE";
    PolaAdvertStatus["LIVE"] = "LIVE";
    PolaAdvertStatus["PROCESSING"] = "PROCESSING";
    PolaAdvertStatus["REBOOKED"] = "REBOOKED";
    PolaAdvertStatus["REMOVED"] = "REMOVED";
})(PolaAdvertStatus || (PolaAdvertStatus = {}));
export var PolaLiveEditPublishStatus;
(function (PolaLiveEditPublishStatus) {
    PolaLiveEditPublishStatus["ERROR_GENERAL"] = "ERROR_GENERAL";
    PolaLiveEditPublishStatus["ERROR_PUBLISH_CONFLICT"] = "ERROR_PUBLISH_CONFLICT";
    PolaLiveEditPublishStatus["SUCCESS"] = "SUCCESS";
})(PolaLiveEditPublishStatus || (PolaLiveEditPublishStatus = {}));
export var PolaVehicleCondition;
(function (PolaVehicleCondition) {
    PolaVehicleCondition["NEW"] = "NEW";
    PolaVehicleCondition["USED"] = "USED";
})(PolaVehicleCondition || (PolaVehicleCondition = {}));
export var PriceIndicatorRating;
(function (PriceIndicatorRating) {
    PriceIndicatorRating["FAIR"] = "FAIR";
    PriceIndicatorRating["GOOD"] = "GOOD";
    PriceIndicatorRating["GREAT"] = "GREAT";
    PriceIndicatorRating["HIGH"] = "HIGH";
    PriceIndicatorRating["LOW"] = "LOW";
})(PriceIndicatorRating || (PriceIndicatorRating = {}));
export var ReservationErrorType;
(function (ReservationErrorType) {
    ReservationErrorType["PROFANITY_CHECK_FAILED"] = "PROFANITY_CHECK_FAILED";
    ReservationErrorType["UNABLE_TO_GET_PAYMENT_SESSION"] = "UNABLE_TO_GET_PAYMENT_SESSION";
    ReservationErrorType["UPDATE_FAILED"] = "UPDATE_FAILED";
})(ReservationErrorType || (ReservationErrorType = {}));
export var ReservationPaymentStatus;
(function (ReservationPaymentStatus) {
    ReservationPaymentStatus["AutoTraderInitiatedRefund"] = "AutoTraderInitiatedRefund";
    ReservationPaymentStatus["ConsumerInitiatedRefund"] = "ConsumerInitiatedRefund";
    ReservationPaymentStatus["ConsumerInitiatedTransfer"] = "ConsumerInitiatedTransfer";
    ReservationPaymentStatus["Initiated"] = "Initiated";
    ReservationPaymentStatus["InitiatedTransfer"] = "InitiatedTransfer";
    ReservationPaymentStatus["RefundComplete"] = "RefundComplete";
    ReservationPaymentStatus["ReservationHeld"] = "ReservationHeld";
    ReservationPaymentStatus["RetailerInitiatedRefund"] = "RetailerInitiatedRefund";
    ReservationPaymentStatus["RetailerInitiatedTransfer"] = "RetailerInitiatedTransfer";
    ReservationPaymentStatus["RetailerPaid"] = "RetailerPaid";
    ReservationPaymentStatus["TransferComplete"] = "TransferComplete";
})(ReservationPaymentStatus || (ReservationPaymentStatus = {}));
export var RetailerLinkageName;
(function (RetailerLinkageName) {
    RetailerLinkageName["NETWORK_MULTI_LOCATION_STOCK_OWNER"] = "NETWORK_MULTI_LOCATION_STOCK_OWNER";
    RetailerLinkageName["SINGLEVIEW_BILLING_OWNER"] = "SINGLEVIEW_BILLING_OWNER";
})(RetailerLinkageName || (RetailerLinkageName = {}));
export var RetailerMediaType;
(function (RetailerMediaType) {
    RetailerMediaType["Image"] = "Image";
    RetailerMediaType["Video"] = "Video";
})(RetailerMediaType || (RetailerMediaType = {}));
export var RetailerType;
(function (RetailerType) {
    RetailerType["new_bike"] = "new_bike";
    RetailerType["new_car"] = "new_car";
    RetailerType["used_bike"] = "used_bike";
    RetailerType["used_car"] = "used_car";
    RetailerType["used_caravan"] = "used_caravan";
    RetailerType["used_farm"] = "used_farm";
    RetailerType["used_motorhome"] = "used_motorhome";
    RetailerType["used_plant"] = "used_plant";
    RetailerType["used_truck"] = "used_truck";
    RetailerType["used_van"] = "used_van";
})(RetailerType || (RetailerType = {}));
export var SearchFacetName;
(function (SearchFacetName) {
    SearchFacetName["acceleration_values"] = "acceleration_values";
    SearchFacetName["advert_classification"] = "advert_classification";
    SearchFacetName["aggregated_trim"] = "aggregated_trim";
    SearchFacetName["annual_tax_values"] = "annual_tax_values";
    SearchFacetName["battery_charge_time_values"] = "battery_charge_time_values";
    SearchFacetName["battery_quick_charge_time_values"] = "battery_quick_charge_time_values";
    SearchFacetName["battery_range_values"] = "battery_range_values";
    SearchFacetName["bedroom_layout"] = "bedroom_layout";
    SearchFacetName["berth"] = "berth";
    SearchFacetName["body_type"] = "body_type";
    SearchFacetName["boot_size_values"] = "boot_size_values";
    SearchFacetName["cab_type"] = "cab_type";
    SearchFacetName["capability"] = "capability";
    SearchFacetName["click_and_collect_available"] = "click_and_collect_available";
    SearchFacetName["click_and_collect_or_home_delivery_available"] = "click_and_collect_or_home_delivery_available";
    SearchFacetName["co2_emission_values"] = "co2_emission_values";
    SearchFacetName["colour"] = "colour";
    SearchFacetName["distance"] = "distance";
    /** @deprecated No longer supported */
    SearchFacetName["doors"] = "doors";
    SearchFacetName["doors_values"] = "doors_values";
    SearchFacetName["driver_position"] = "driver_position";
    SearchFacetName["drivetrain"] = "drivetrain";
    SearchFacetName["emission_scheme"] = "emission_scheme";
    SearchFacetName["end_layout"] = "end_layout";
    SearchFacetName["finance_option_deposits"] = "finance_option_deposits";
    SearchFacetName["finance_option_mileages"] = "finance_option_mileages";
    SearchFacetName["finance_option_terms"] = "finance_option_terms";
    SearchFacetName["fuel_consumption_values"] = "fuel_consumption_values";
    SearchFacetName["fuel_type"] = "fuel_type";
    SearchFacetName["home_delivery_adverts"] = "home_delivery_adverts";
    SearchFacetName["is_manufacturer_approved"] = "is_manufacturer_approved";
    SearchFacetName["is_seller_defined_used"] = "is_seller_defined_used";
    SearchFacetName["is_writeoff"] = "is_writeoff";
    SearchFacetName["licence_type"] = "licence_type";
    SearchFacetName["make"] = "make";
    SearchFacetName["max_battery_charge_time"] = "max_battery_charge_time";
    SearchFacetName["max_battery_quick_charge_time"] = "max_battery_quick_charge_time";
    SearchFacetName["max_battery_range"] = "max_battery_range";
    SearchFacetName["max_boot_size"] = "max_boot_size";
    SearchFacetName["max_engine_power"] = "max_engine_power";
    SearchFacetName["max_engine_size"] = "max_engine_size";
    SearchFacetName["max_engine_size_cc"] = "max_engine_size_cc";
    SearchFacetName["max_exterior_length"] = "max_exterior_length";
    SearchFacetName["max_insurance_group"] = "max_insurance_group";
    SearchFacetName["max_lease_monthly_price_ex_vat"] = "max_lease_monthly_price_ex_vat";
    SearchFacetName["max_mileage"] = "max_mileage";
    SearchFacetName["max_monthly_price"] = "max_monthly_price";
    SearchFacetName["max_mtplm"] = "max_mtplm";
    SearchFacetName["max_price"] = "max_price";
    SearchFacetName["max_seats"] = "max_seats";
    SearchFacetName["max_supplied_price"] = "max_supplied_price";
    SearchFacetName["max_year_manufactured"] = "max_year_manufactured";
    SearchFacetName["min_battery_charge_time"] = "min_battery_charge_time";
    SearchFacetName["min_battery_quick_charge_time"] = "min_battery_quick_charge_time";
    SearchFacetName["min_battery_range"] = "min_battery_range";
    SearchFacetName["min_boot_size"] = "min_boot_size";
    SearchFacetName["min_engine_power"] = "min_engine_power";
    SearchFacetName["min_engine_size"] = "min_engine_size";
    SearchFacetName["min_engine_size_cc"] = "min_engine_size_cc";
    SearchFacetName["min_exterior_length"] = "min_exterior_length";
    SearchFacetName["min_insurance_group"] = "min_insurance_group";
    SearchFacetName["min_lease_monthly_price_ex_vat"] = "min_lease_monthly_price_ex_vat";
    SearchFacetName["min_mileage"] = "min_mileage";
    SearchFacetName["min_monthly_price"] = "min_monthly_price";
    SearchFacetName["min_mtplm"] = "min_mtplm";
    SearchFacetName["min_price"] = "min_price";
    SearchFacetName["min_seats"] = "min_seats";
    SearchFacetName["min_supplied_price"] = "min_supplied_price";
    SearchFacetName["min_year_manufactured"] = "min_year_manufactured";
    SearchFacetName["model"] = "model";
    SearchFacetName["monthly_price"] = "monthly_price";
    SearchFacetName["part_exchange_available"] = "part_exchange_available";
    SearchFacetName["postal_region"] = "postal_region";
    SearchFacetName["price"] = "price";
    SearchFacetName["retailer_id"] = "retailer_id";
    SearchFacetName["seller_type"] = "seller_type";
    SearchFacetName["style"] = "style";
    SearchFacetName["trailer_axle_number"] = "trailer_axle_number";
    SearchFacetName["transmission"] = "transmission";
    SearchFacetName["wheelbase"] = "wheelbase";
    SearchFacetName["with_digital_retailing"] = "with_digital_retailing";
    SearchFacetName["with_manufacturer_rrp_saving"] = "with_manufacturer_rrp_saving";
})(SearchFacetName || (SearchFacetName = {}));
export var SellTileAdvertStatus;
(function (SellTileAdvertStatus) {
    SellTileAdvertStatus["EXPIRED"] = "EXPIRED";
    SellTileAdvertStatus["EXPIRING"] = "EXPIRING";
    SellTileAdvertStatus["INCOMPLETE"] = "INCOMPLETE";
    SellTileAdvertStatus["LIVE"] = "LIVE";
})(SellTileAdvertStatus || (SellTileAdvertStatus = {}));
export var Sort;
(function (Sort) {
    Sort["AGE_NEWEST_FIRST"] = "AGE_NEWEST_FIRST";
    Sort["ATTRACTIVENESS_ASC"] = "ATTRACTIVENESS_ASC";
    Sort["ATTRACTIVENESS_DESC"] = "ATTRACTIVENESS_DESC";
    Sort["DISCOUNT_DESC"] = "DISCOUNT_DESC";
    Sort["DISCOUNT_PERCENTAGE_DESC"] = "DISCOUNT_PERCENTAGE_DESC";
    Sort["DISTANCE"] = "DISTANCE";
    Sort["EXPERIMENTAL"] = "EXPERIMENTAL";
    Sort["LEASE_BEST_VALUE_ASC"] = "LEASE_BEST_VALUE_ASC";
    Sort["LEASE_PRICE_HIGH"] = "LEASE_PRICE_HIGH";
    Sort["LEASE_PRICE_LOW"] = "LEASE_PRICE_LOW";
    Sort["LEASE_RELEVANCE"] = "LEASE_RELEVANCE";
    Sort["MAKE"] = "MAKE";
    Sort["MILEAGE"] = "MILEAGE";
    Sort["MILEAGE_ASC"] = "MILEAGE_ASC";
    Sort["MILEAGE_DESC"] = "MILEAGE_DESC";
    Sort["MODEL"] = "MODEL";
    Sort["MONTHLY_PRICE_ASC"] = "MONTHLY_PRICE_ASC";
    Sort["MONTHLY_PRICE_DESC"] = "MONTHLY_PRICE_DESC";
    Sort["MOST_RECENT"] = "MOST_RECENT";
    Sort["MOST_RECENT_WITH_IMAGES"] = "MOST_RECENT_WITH_IMAGES";
    Sort["NATIONAL_DESIRABILITY_ASC"] = "NATIONAL_DESIRABILITY_ASC";
    Sort["NATIONAL_DESIRABILITY_DESC"] = "NATIONAL_DESIRABILITY_DESC";
    Sort["PLACEMENT_DESC"] = "PLACEMENT_DESC";
    Sort["PLACEMENT_DESC_WITH_IMAGES"] = "PLACEMENT_DESC_WITH_IMAGES";
    Sort["PREMIUM_DOWNGRADE"] = "PREMIUM_DOWNGRADE";
    Sort["PREMIUM_UPGRADE"] = "PREMIUM_UPGRADE";
    Sort["PRICE_HIGH"] = "PRICE_HIGH";
    Sort["PRICE_LOW"] = "PRICE_LOW";
    Sort["REGISTRATION_DATE_ASC"] = "REGISTRATION_DATE_ASC";
    Sort["REGISTRATION_DATE_DESC"] = "REGISTRATION_DATE_DESC";
    Sort["RELEVANCE"] = "RELEVANCE";
    Sort["RELEVANCE_IGNORING_DISTANCE"] = "RELEVANCE_IGNORING_DISTANCE";
    Sort["SPONSORED"] = "SPONSORED";
    Sort["SPONSORED_SUPPLIED_PRICE"] = "SPONSORED_SUPPLIED_PRICE";
    Sort["SUPPLIED_PRICE_ASC"] = "SUPPLIED_PRICE_ASC";
    Sort["SUPPLIED_PRICE_DESC"] = "SUPPLIED_PRICE_DESC";
    Sort["VERSION_DAYS_OLD"] = "VERSION_DAYS_OLD";
    Sort["WITH_IMAGES_AND_DISCOUNT_FIRST"] = "WITH_IMAGES_AND_DISCOUNT_FIRST";
    Sort["YEAR_ASC"] = "YEAR_ASC";
    Sort["YEAR_DESC"] = "YEAR_DESC";
    Sort["YEAR_DESC_PRICE_ASC"] = "YEAR_DESC_PRICE_ASC";
})(Sort || (Sort = {}));
export var UnpublishAdvertReason;
(function (UnpublishAdvertReason) {
    UnpublishAdvertReason["GAVE_FRIEND_OR_FAMILY"] = "GAVE_FRIEND_OR_FAMILY";
    UnpublishAdvertReason["NEW_AD"] = "NEW_AD";
    UnpublishAdvertReason["NO_SALE"] = "NO_SALE";
    UnpublishAdvertReason["OTHER"] = "OTHER";
    UnpublishAdvertReason["SOCIAL_DISTANCING"] = "SOCIAL_DISTANCING";
    UnpublishAdvertReason["SOLD_AUCTION"] = "SOLD_AUCTION";
    UnpublishAdvertReason["SOLD_AUTO_TRADER"] = "SOLD_AUTO_TRADER";
    UnpublishAdvertReason["SOLD_COMPANY_USED_CARS"] = "SOLD_COMPANY_USED_CARS";
    UnpublishAdvertReason["SOLD_DEALER"] = "SOLD_DEALER";
    UnpublishAdvertReason["SOLD_EBAY"] = "SOLD_EBAY";
    UnpublishAdvertReason["SOLD_FACEBOOK"] = "SOLD_FACEBOOK";
    UnpublishAdvertReason["SOLD_FRIEND_OR_FAMILY"] = "SOLD_FRIEND_OR_FAMILY";
    UnpublishAdvertReason["SOLD_GUMTREE"] = "SOLD_GUMTREE";
    UnpublishAdvertReason["SOLD_PART_EX"] = "SOLD_PART_EX";
    UnpublishAdvertReason["SOLD_PISTONHEADS"] = "SOLD_PISTONHEADS";
    UnpublishAdvertReason["SOLD_PRIVATE_BUYER"] = "SOLD_PRIVATE_BUYER";
    UnpublishAdvertReason["SOLD_SHPOCK"] = "SOLD_SHPOCK";
    UnpublishAdvertReason["SOLD_WE_BUY_ANY_CAR"] = "SOLD_WE_BUY_ANY_CAR";
})(UnpublishAdvertReason || (UnpublishAdvertReason = {}));
export var UpdateAdvertFieldAction;
(function (UpdateAdvertFieldAction) {
    UpdateAdvertFieldAction["add"] = "add";
    UpdateAdvertFieldAction["remove"] = "remove";
    UpdateAdvertFieldAction["replace"] = "replace";
})(UpdateAdvertFieldAction || (UpdateAdvertFieldAction = {}));
export var UpdateAdvertFieldName;
(function (UpdateAdvertFieldName) {
    UpdateAdvertFieldName["advertFeature"] = "advertFeature";
    UpdateAdvertFieldName["allowContactByEmail"] = "allowContactByEmail";
    UpdateAdvertFieldName["axleConfiguration"] = "axleConfiguration";
    UpdateAdvertFieldName["bathroomType"] = "bathroomType";
    UpdateAdvertFieldName["bedLayout"] = "bedLayout";
    UpdateAdvertFieldName["bodyType"] = "bodyType";
    UpdateAdvertFieldName["cabType"] = "cabType";
    UpdateAdvertFieldName["capacityLiftingWeightUnit"] = "capacityLiftingWeightUnit";
    UpdateAdvertFieldName["capacityLiftingWeightValue"] = "capacityLiftingWeightValue";
    UpdateAdvertFieldName["chassisMake"] = "chassisMake";
    UpdateAdvertFieldName["chassisModel"] = "chassisModel";
    UpdateAdvertFieldName["colour"] = "colour";
    UpdateAdvertFieldName["derivative"] = "derivative";
    UpdateAdvertFieldName["derivativeId"] = "derivativeId";
    UpdateAdvertFieldName["description"] = "description";
    UpdateAdvertFieldName["driverPosition"] = "driverPosition";
    UpdateAdvertFieldName["email"] = "email";
    UpdateAdvertFieldName["emissionClass"] = "emissionClass";
    UpdateAdvertFieldName["endLayout"] = "endLayout";
    UpdateAdvertFieldName["engineCapacityCC"] = "engineCapacityCC";
    UpdateAdvertFieldName["enginePowerBHP"] = "enginePowerBHP";
    UpdateAdvertFieldName["enginePowerKW"] = "enginePowerKW";
    UpdateAdvertFieldName["enginePowerPS"] = "enginePowerPS";
    UpdateAdvertFieldName["externalHeightMillimetres"] = "externalHeightMillimetres";
    UpdateAdvertFieldName["externalLengthMillimetres"] = "externalLengthMillimetres";
    UpdateAdvertFieldName["externalWidthMillimetres"] = "externalWidthMillimetres";
    UpdateAdvertFieldName["firstName"] = "firstName";
    UpdateAdvertFieldName["firstRegistrationDate"] = "firstRegistrationDate";
    UpdateAdvertFieldName["fuelType"] = "fuelType";
    UpdateAdvertFieldName["generation"] = "generation";
    UpdateAdvertFieldName["grossTrailerWeightUnit"] = "grossTrailerWeightUnit";
    UpdateAdvertFieldName["grossTrailerWeightValue"] = "grossTrailerWeightValue";
    UpdateAdvertFieldName["grossVehicleWeightUnit"] = "grossVehicleWeightUnit";
    UpdateAdvertFieldName["grossVehicleWeightValue"] = "grossVehicleWeightValue";
    UpdateAdvertFieldName["hoursInOperation"] = "hoursInOperation";
    UpdateAdvertFieldName["image"] = "image";
    UpdateAdvertFieldName["lastName"] = "lastName";
    UpdateAdvertFieldName["make"] = "make";
    UpdateAdvertFieldName["maxPayloadKg"] = "maxPayloadKg";
    UpdateAdvertFieldName["maxReachUnit"] = "maxReachUnit";
    UpdateAdvertFieldName["maxReachValue"] = "maxReachValue";
    UpdateAdvertFieldName["mileage"] = "mileage";
    UpdateAdvertFieldName["miroKg"] = "miroKg";
    UpdateAdvertFieldName["model"] = "model";
    UpdateAdvertFieldName["motExpiryDate"] = "motExpiryDate";
    UpdateAdvertFieldName["numberOfBedrooms"] = "numberOfBedrooms";
    UpdateAdvertFieldName["numberOfBerths"] = "numberOfBerths";
    UpdateAdvertFieldName["numberOfOwners"] = "numberOfOwners";
    UpdateAdvertFieldName["operatingHeightUnit"] = "operatingHeightUnit";
    UpdateAdvertFieldName["operatingHeightValue"] = "operatingHeightValue";
    UpdateAdvertFieldName["operatingType"] = "operatingType";
    UpdateAdvertFieldName["operatingWidthUnit"] = "operatingWidthUnit";
    UpdateAdvertFieldName["operatingWidthValue"] = "operatingWidthValue";
    UpdateAdvertFieldName["postcode"] = "postcode";
    UpdateAdvertFieldName["price"] = "price";
    UpdateAdvertFieldName["primaryTelephone"] = "primaryTelephone";
    UpdateAdvertFieldName["seats"] = "seats";
    UpdateAdvertFieldName["secondaryTelephone"] = "secondaryTelephone";
    UpdateAdvertFieldName["serviceHistory"] = "serviceHistory";
    UpdateAdvertFieldName["subtitle"] = "subtitle";
    UpdateAdvertFieldName["trade"] = "trade";
    UpdateAdvertFieldName["transmissionType"] = "transmissionType";
    UpdateAdvertFieldName["trim"] = "trim";
    UpdateAdvertFieldName["vatStatus"] = "vatStatus";
    UpdateAdvertFieldName["videoUrl"] = "videoUrl";
    UpdateAdvertFieldName["volumeCapacityUnit"] = "volumeCapacityUnit";
    UpdateAdvertFieldName["volumeCapacityValue"] = "volumeCapacityValue";
    UpdateAdvertFieldName["wheelbaseType"] = "wheelbaseType";
})(UpdateAdvertFieldName || (UpdateAdvertFieldName = {}));
export var UserLevel;
(function (UserLevel) {
    UserLevel["SIGNED_IN"] = "SIGNED_IN";
    UserLevel["SIGNED_IN_RECENTLY"] = "SIGNED_IN_RECENTLY";
})(UserLevel || (UserLevel = {}));
export var UserState;
(function (UserState) {
    UserState["New"] = "New";
    UserState["Registered"] = "Registered";
    UserState["SoftReg"] = "SoftReg";
})(UserState || (UserState = {}));
export var ValidationStatus;
(function (ValidationStatus) {
    ValidationStatus["INVALID"] = "INVALID";
    ValidationStatus["UNAVAILABLE"] = "UNAVAILABLE";
    ValidationStatus["UNCHANGED"] = "UNCHANGED";
    ValidationStatus["VALID"] = "VALID";
})(ValidationStatus || (ValidationStatus = {}));
export var VatStatus;
(function (VatStatus) {
    VatStatus["INC_VAT"] = "INC_VAT";
    VatStatus["NO_VAT"] = "NO_VAT";
    VatStatus["PLUS_VAT"] = "PLUS_VAT";
})(VatStatus || (VatStatus = {}));
export var VehicleChannel;
(function (VehicleChannel) {
    VehicleChannel["bikes"] = "bikes";
    VehicleChannel["caravans"] = "caravans";
    VehicleChannel["cars"] = "cars";
    VehicleChannel["cycles"] = "cycles";
    VehicleChannel["farm"] = "farm";
    VehicleChannel["motorhomes"] = "motorhomes";
    VehicleChannel["plant"] = "plant";
    VehicleChannel["trucks"] = "trucks";
    VehicleChannel["vans"] = "vans";
})(VehicleChannel || (VehicleChannel = {}));
export var VehicleCheckKey;
(function (VehicleCheckKey) {
    VehicleCheckKey["COLOUR_CHANGED"] = "COLOUR_CHANGED";
    VehicleCheckKey["EXPORTED"] = "EXPORTED";
    VehicleCheckKey["HIGH_RISK"] = "HIGH_RISK";
    VehicleCheckKey["IMPORTED"] = "IMPORTED";
    VehicleCheckKey["MILEAGE_DISCREPANCY"] = "MILEAGE_DISCREPANCY";
    VehicleCheckKey["PRIVATE_FINANCE"] = "PRIVATE_FINANCE";
    VehicleCheckKey["REGISTRATION_CHANGED"] = "REGISTRATION_CHANGED";
    VehicleCheckKey["SCRAPPED"] = "SCRAPPED";
    VehicleCheckKey["STOLEN"] = "STOLEN";
    VehicleCheckKey["TRADE_FINANCE"] = "TRADE_FINANCE";
    VehicleCheckKey["WRITE_OFF_CATEGORY"] = "WRITE_OFF_CATEGORY";
})(VehicleCheckKey || (VehicleCheckKey = {}));
export var VehicleCheckStatus;
(function (VehicleCheckStatus) {
    VehicleCheckStatus["FAILED"] = "FAILED";
    VehicleCheckStatus["PASSED"] = "PASSED";
    VehicleCheckStatus["UNAVAILABLE"] = "UNAVAILABLE";
})(VehicleCheckStatus || (VehicleCheckStatus = {}));
export var VehicleChecks;
(function (VehicleChecks) {
    VehicleChecks["BASIC"] = "BASIC";
    VehicleChecks["FULL"] = "FULL";
    VehicleChecks["MISSING"] = "MISSING";
})(VehicleChecks || (VehicleChecks = {}));
